import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import Gradient from "../gradient/gradient";
import Wave from "../wave/wave";
import {
  backgroundImageInnerStyle,
  backgroundImageWrapperStyle,
  bottomPaddingSmallStyle,
  careersPrimaryBackgroundImageStyle,
  careersSecondaryBackgroundImageStyle,
  innerContentStyle,
} from "./svg_background_image.module.scss";

// ——————————————————————————————————————————————————————————————————————————————
//      NOTES
// ——————————————————————————————————————————————————————————————————————————————
// Artwork for this component needs to be formatted a certain way to ensure consistency across components.
// — Aspect ratio: 10:3
// — Format: SVG
// — Recommended dimensions: 3840 x 1152 (not a hard requirement)
// — Image should not contain a background color — the gradient prop should be used for this

function SVGBackgroundHeroWrapper({
  children,
  background,
  hasWave,
  bottomPaddingSize,
}) {
  const innerClassNames = classNames(backgroundImageInnerStyle, {
    [careersPrimaryBackgroundImageStyle]: background === "careers_primary",
    [careersSecondaryBackgroundImageStyle]: background === "careers_secondary",
  });

  const innerContentClassNames = classNames(innerContentStyle, {
    [bottomPaddingSmallStyle]: bottomPaddingSize === "small",
  });

  // ToDo: (AMG) [Tech debt] [Feedback: Careers hub] Come up with cleaner solution for setting gradient in SVG background image component
  const gradient =
    background === "careers_primary" || background === "careers_secondary"
      ? "people"
      : "default";

  return (
    <div
      data-testid="svg-background-hero-wrapper"
      className={backgroundImageWrapperStyle}
    >
      <Gradient gradient={gradient} />
      <div className={innerClassNames} />
      <div className={innerContentClassNames}>{children}</div>
      {hasWave && <Wave wave={15} position="bottom" />}
    </div>
  );
}

SVGBackgroundHeroWrapper.propTypes = {
  children: PropTypes.node,
  background: PropTypes.oneOf([
    "default",
    "careers_primary",
    "careers_secondary",
  ]),
  hasWave: PropTypes.bool,
  bottomPaddingSize: PropTypes.oneOf(["small", "large"]),
};

SVGBackgroundHeroWrapper.defaultProps = {
  children: null,
  background: "default",
  hasWave: false,
  bottomPaddingSize: "large",
};

export default SVGBackgroundHeroWrapper;
